try {
    window.jQuery = require('./../../node_modules/jquery');
 } catch (e) {
     console.log(e);
 }
 
try {
   window.Form = require('./send.js');
} catch (e) {
    console.log('Error with requiring file send.js');
}





// WEBPACK FOOTER //
// ./_dev/js/app.js